namespace Riepiloghi.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
